"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

var _logger = require("@insided/shared/services/logger");

var _ProfileModal = _interopRequireDefault(require("./ProfileModal"));

var _userService = require("./userService");

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _BanUserModal = _interopRequireDefault(require("./BanUserModal"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ViewProfile = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(ViewProfile, _PureComponent);

  var _super = _createSuper(ViewProfile);

  function ViewProfile() {
    var _this;

    (0, _classCallCheck2.default)(this, ViewProfile);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loggedInUserId", (0, _insidedDataStorage.getInsidedData)('user').userid);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      showBanUserModal: false,
      showProfileModal: false,
      profileData: null,
      isLoading: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getProfileData", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var authorId, profileData;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              authorId = _this.props.authorId;

              _this.setState({
                isLoading: true
              });

              _context.prev = 2;
              _context.next = 5;
              return (0, _userService.getProfileData)(authorId);

            case 5:
              profileData = _context.sent;

              _this.setState({
                showProfileModal: true,
                profileData: profileData
              });

              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](2);

              _logger.logger.error(_context.t0, {
                component: 'ViewProfile',
                action: 'getProfileData'
              });

            case 12:
              _this.setState({
                isLoading: false
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 9]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCloseProfileModal", function () {
      _this.setState({
        showProfileModal: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showBanUserModal", function (showBanUserModal) {
      _this.setState({
        showBanUserModal: showBanUserModal
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "banUser", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var authorId;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              authorId = _this.props.authorId;
              _context2.prev = 1;

              _this.setState({
                isLoading: true
              });

              _context2.next = 5;
              return (0, _userService.banUser)(authorId);

            case 5:
              _this.setState(function (prevState) {
                return {
                  profileData: prevState.profileData ? _objectSpread(_objectSpread({}, prevState.profileData), {}, {
                    isBanned: !prevState.profileData.isBanned
                  }) : null,
                  showBanUserModal: false
                };
              });

              _context2.next = 11;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);

              _logger.logger.error(_context2.t0, {
                component: 'ViewProfile',
                action: 'banUser'
              });

            case 11:
              _this.setState({
                isLoading: false
              });

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 8]]);
    })));
    return _this;
  }

  (0, _createClass2.default)(ViewProfile, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          authorId = _this$props.authorId,
          author = _this$props.author;
      var _this$state = this.state,
          showProfileModal = _this$state.showProfileModal,
          profileData = _this$state.profileData,
          showBanUserModal = _this$state.showBanUserModal,
          isLoading = _this$state.isLoading;
      return (0, _preact.h)("div", {
        className: "topic-moderation__profile-button"
      }, (0, _preact.h)("span", {
        onClick: this.getProfileData,
        role: "button",
        tabIndex: 0,
        onKeyDown: function onKeyDown(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();

            _this2.getProfileData();
          }
        }
      }, "View profile"), showProfileModal && profileData && (0, _preact.h)(_ProfileModal.default, {
        authorId: authorId,
        getProfileData: this.getProfileData,
        profileData: profileData,
        onClose: this.onCloseProfileModal,
        author: author,
        badges: profileData.badges,
        reputationLevel: profileData.userStatistics.reputationLevel,
        rank: profileData.rank,
        isBanned: profileData.isBanned,
        loggedInUserId: this.loggedInUserId,
        showBanUserModal: this.showBanUserModal,
        banUser: this.banUser
      }), showBanUserModal && (0, _preact.h)(_BanUserModal.default, {
        onClose: function onClose() {
          return _this2.showBanUserModal(false);
        },
        userName: author.username,
        userId: authorId,
        banUser: this.banUser,
        isLoading: isLoading
      }));
    }
  }]);
  return ViewProfile;
}(_preactCompat.PureComponent);

var _default = ViewProfile;
exports.default = _default;